import React from 'react';
import { Container } from 'react-bootstrap';
import useModal from '../../hooks/useModal';
import Button from '../Button';
import { Email } from './EmailForm';
import EmailFormModal from './EmailFormModal';

const testEmail: Email = {
  type: 'personal',
  email: 'example@test.com',
};

const EmailFormDemo = () => {
  const [showModal, handleShow, handleClose] = useModal();

  const [email] = React.useState<Email>(testEmail);

  const handleSubmit = () => {
    console.log('submit', email);
    handleClose();
  };

  return (
    <Container>
      <Container className="mt-10">
        <h4>Email Form Modal</h4>
        <Container className="d-flex justify-content-between flex-wrap align-items-center p-0">
          <Button variant="primary" onMouseDown={handleShow}>
            Add address
          </Button>
          <EmailFormModal
            showModal={showModal}
            handleClose={handleClose}
            handleSubmit={handleSubmit}
          />
        </Container>
      </Container>
    </Container>
  );
};

export default EmailFormDemo;
